module.exports = __webpack_public_path__ + "img/aya_1x1.f4c7bbf0.webp";